import type {AuthenticatedUser} from "auth/types";
import {createSessionStore} from "utils/storage";
import {isTokenExpired} from "utils/tokens";

export const AUTH_SESSION_KEY = "authUser";
export const authStore =
  createSessionStore<AuthenticatedUser>(AUTH_SESSION_KEY);

export const persistUserToSession = (
  user: AuthenticatedUser | null | undefined,
) => {
  authStore.set(user ?? null);
};

export const readUserFromSession = (): AuthenticatedUser | null => {
  const user = authStore.get();
  if (!user?.token) return null;

  if (isTokenExpired(user.token)) {
    authStore.set(null);
    return null;
  }

  return user;
};
